// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.department-redesign-layout {
  min-height: 100vh;
}

.department-redesign-content {
  flex: 1 1;
  min-width: 0;
  padding: 30px 36px;
  background: #f5f7fb;
  box-sizing: border-box;
}

.dp-page {
  width: 100%;
  color: #203047;
  font-family: 'Malgun Gothic', Arial, sans-serif;
}

.dp-top {
  margin-bottom: 22px;
}

.dp-back {
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}

.dp-back:hover {
  color: #168ff0;
}

.dp-heading {
  margin-bottom: 24px;
}

.dp-heading h2 {
  margin: 0 0 8px;
  font-size: 25px;
  font-weight: 800;
}

.dp-heading p {
  margin: 0;
  font-size: 14px;
  color: #8190a4;
}

.dp-card {
  background: #fff;
  border: 1px solid #e4eaf1;
  border-radius: 12px;
  padding: 26px;
  box-shadow: 0 2px 12px #19355409;
  margin-bottom: 22px;
}

.dp-card-title {
  padding-bottom: 18px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e9edf3;
}

.dp-card-title h3 {
  margin: 0 0 6px;
  font-size: 19px;
  font-weight: 800;
}

.dp-card-title span {
  font-size: 13px;
  color: #8190a4;
}

.dp-add-row {
  display: flex;
  gap: 12px;
}

.dp-add-row input {
  flex: 1 1;
  min-width: 0;
  height: 44px;
  box-sizing: border-box;
  border: 1px solid #dce4ee;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 14px;
}

.dp-add-row input:focus,
.dp-dept-name input:focus {
  outline: 2px solid #90c7ff;
  outline-offset: 1px;
}

.dp-primary {
  border: 1px solid #168ff0;
  background: #168ff0;
  color: #fff;
  border-radius: 8px;
  padding: 0 24px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.dp-primary:hover {
  background: #087bd4;
}

.dp-table-wrap {
  width: 100%;
  overflow-x: auto;
}

.dp-table {
  width: 100%;
  min-width: 650px;
  border-collapse: collapse;
  text-align: center;
  font-size: 12px;
}

.dp-table th {
  background: #f1f5fa;
  color: #3b4c62;
  border-top: 2px solid #2196f3;
  padding: 14px 9px;
}

.dp-table td {
  height: 54px;
  padding: 9px;
  border-bottom: 1px solid #e8edf3;
  box-sizing: border-box;
}

.dp-table tbody tr:hover {
  background: #f8fbff;
}

.dp-dept-name {
  text-align: left;
  font-weight: 600;
  color: #34465b;
}

.dp-dept-name input {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  border: 1px solid #dce4ee;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 13px;
}

.dp-row-actions {
  display: flex;
  justify-content: center;
  gap: 6px;
}

.dp-edit,
.dp-save,
.dp-cancel,
.dp-delete {
  border-radius: 6px;
  padding: 7px 13px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.dp-edit,
.dp-cancel {
  background: #fff;
  color: #475569;
  border: 1px solid #dce4ee;
}

.dp-save {
  background: #168ff0;
  color: #fff;
  border: 1px solid #168ff0;
}

.dp-delete {
  background: #fff;
  color: #dc2626;
  border: 1px solid #f3c4c4;
}

.dp-empty {
  text-align: center;
  padding: 40px !important;
  color: #8190a4;
}

.dp-bottom {
  margin-top: 18px;
  color: #8190a4;
  font-size: 12px;
}

.dp-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}

.dp-secondary {
  border: 1px solid #dce4ee;
  background: #fff;
  color: #475569;
  border-radius: 9px;
  padding: 13px 24px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

@media (max-width: 768px) {
  .department-redesign-content {
    padding: 20px 16px;
  }

  .dp-card {
    padding: 20px;
  }

  .dp-add-row {
    flex-wrap: wrap;
  }

  .dp-add-row input {
    flex-basis: 100%;
  }

  .dp-primary {
    height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/DepartmentPlusRedesign.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;;;EAIE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".department-redesign-layout {\n  min-height: 100vh;\n}\n\n.department-redesign-content {\n  flex: 1;\n  min-width: 0;\n  padding: 30px 36px;\n  background: #f5f7fb;\n  box-sizing: border-box;\n}\n\n.dp-page {\n  width: 100%;\n  color: #203047;\n  font-family: 'Malgun Gothic', Arial, sans-serif;\n}\n\n.dp-top {\n  margin-bottom: 22px;\n}\n\n.dp-back {\n  border: none;\n  background: transparent;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n}\n\n.dp-back:hover {\n  color: #168ff0;\n}\n\n.dp-heading {\n  margin-bottom: 24px;\n}\n\n.dp-heading h2 {\n  margin: 0 0 8px;\n  font-size: 25px;\n  font-weight: 800;\n}\n\n.dp-heading p {\n  margin: 0;\n  font-size: 14px;\n  color: #8190a4;\n}\n\n.dp-card {\n  background: #fff;\n  border: 1px solid #e4eaf1;\n  border-radius: 12px;\n  padding: 26px;\n  box-shadow: 0 2px 12px #19355409;\n  margin-bottom: 22px;\n}\n\n.dp-card-title {\n  padding-bottom: 18px;\n  margin-bottom: 24px;\n  border-bottom: 1px solid #e9edf3;\n}\n\n.dp-card-title h3 {\n  margin: 0 0 6px;\n  font-size: 19px;\n  font-weight: 800;\n}\n\n.dp-card-title span {\n  font-size: 13px;\n  color: #8190a4;\n}\n\n.dp-add-row {\n  display: flex;\n  gap: 12px;\n}\n\n.dp-add-row input {\n  flex: 1;\n  min-width: 0;\n  height: 44px;\n  box-sizing: border-box;\n  border: 1px solid #dce4ee;\n  border-radius: 8px;\n  padding: 0 12px;\n  font-size: 14px;\n}\n\n.dp-add-row input:focus,\n.dp-dept-name input:focus {\n  outline: 2px solid #90c7ff;\n  outline-offset: 1px;\n}\n\n.dp-primary {\n  border: 1px solid #168ff0;\n  background: #168ff0;\n  color: #fff;\n  border-radius: 8px;\n  padding: 0 24px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.dp-primary:hover {\n  background: #087bd4;\n}\n\n.dp-table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.dp-table {\n  width: 100%;\n  min-width: 650px;\n  border-collapse: collapse;\n  text-align: center;\n  font-size: 12px;\n}\n\n.dp-table th {\n  background: #f1f5fa;\n  color: #3b4c62;\n  border-top: 2px solid #2196f3;\n  padding: 14px 9px;\n}\n\n.dp-table td {\n  height: 54px;\n  padding: 9px;\n  border-bottom: 1px solid #e8edf3;\n  box-sizing: border-box;\n}\n\n.dp-table tbody tr:hover {\n  background: #f8fbff;\n}\n\n.dp-dept-name {\n  text-align: left;\n  font-weight: 600;\n  color: #34465b;\n}\n\n.dp-dept-name input {\n  width: 100%;\n  height: 36px;\n  box-sizing: border-box;\n  border: 1px solid #dce4ee;\n  border-radius: 6px;\n  padding: 0 10px;\n  font-size: 13px;\n}\n\n.dp-row-actions {\n  display: flex;\n  justify-content: center;\n  gap: 6px;\n}\n\n.dp-edit,\n.dp-save,\n.dp-cancel,\n.dp-delete {\n  border-radius: 6px;\n  padding: 7px 13px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.dp-edit,\n.dp-cancel {\n  background: #fff;\n  color: #475569;\n  border: 1px solid #dce4ee;\n}\n\n.dp-save {\n  background: #168ff0;\n  color: #fff;\n  border: 1px solid #168ff0;\n}\n\n.dp-delete {\n  background: #fff;\n  color: #dc2626;\n  border: 1px solid #f3c4c4;\n}\n\n.dp-empty {\n  text-align: center;\n  padding: 40px !important;\n  color: #8190a4;\n}\n\n.dp-bottom {\n  margin-top: 18px;\n  color: #8190a4;\n  font-size: 12px;\n}\n\n.dp-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n.dp-secondary {\n  border: 1px solid #dce4ee;\n  background: #fff;\n  color: #475569;\n  border-radius: 9px;\n  padding: 13px 24px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n@media (max-width: 768px) {\n  .department-redesign-content {\n    padding: 20px 16px;\n  }\n\n  .dp-card {\n    padding: 20px;\n  }\n\n  .dp-add-row {\n    flex-wrap: wrap;\n  }\n\n  .dp-add-row input {\n    flex-basis: 100%;\n  }\n\n  .dp-primary {\n    height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
